import { useIntl } from 'react-intl';
import MfaAckRow from './MfaAckRow';

/**
 * "I saved them" acknowledgment — the generic `MfaAckRow` with the recovery
 * codes copy. `nudge` pulses the row's ring after a save.
 */
export default function MfaRecoveryAckRow({ acknowledged, onChange, nudge = false, reducedMotion = false }) {
  const intl = useIntl();
  return (
    <MfaAckRow
      checked={acknowledged}
      onChange={onChange}
      testId="mfa-recovery-ack-checkbox"
      nudge={nudge}
      reducedMotion={reducedMotion}
      title={intl.formatMessage({ id: 'twoFactor.recovery.saved', defaultMessage: "I've saved them" })}
      sub={intl.formatMessage({ id: 'mfaStepper.codes.ackSub', defaultMessage: 'Somewhere private. Anything you save to iCloud or Files stays there.' })}
    />
  );
}
